import { Store } from "pullstate";

export type ErrorStore = {
  url: string | undefined;
  operationId: string | undefined;
  message: string | undefined;
  error: boolean;
};

const errorStore = new Store<ErrorStore>({
  url: undefined,
  operationId: undefined,
  message: undefined,
  error: false,
});

export default errorStore;
